import { z } from 'zod';

export const sectionSchema = z.object({
  title: z.string().min(1, 'Section title is required').trim(),
});

export type SectionFormValues = z.infer<typeof sectionSchema>;

export const lessonSchema = z.object({
  title: z.string().min(1, 'Lesson title is required').trim(),
  sectionId: z.number({ message: 'Please select a section for this lesson' }),
  section: z.string(),
  lessonType: z.enum(['ILTS', 'Content-Based']),
  lessonDuration: z.string().optional(),
  description: z.string().optional(),
  skills: z.array(z.string()).optional(),

  // Content-Based fields
  contentType: z.enum(['document', 'scorm', 'mp4', 'url', 'quiz']).optional(),
  contentUrl: z.string().optional(),
  lessonContentDocument: z.union([z.string(), z.instanceof(File)]).optional(),
  videoUpload: z.union([z.string(), z.instanceof(File)]).optional(),
  scormPackage: z.union([z.string(), z.instanceof(File)]).optional(),

  // Quiz/Assessment fields
  assessmentId: z.number().optional(),
  requireSectionCompletion: z.boolean().optional(),
  assessmentStartDate: z.string().optional(),
  assessmentEndDate: z.string().optional(),

  // ILTS fields
  iltsType: z.enum(['Online', 'Offline']).optional(),
  iltsUrl: z.string().optional(),
  startDate: z.string().optional(),
  startTime: z.string().optional(),
  endDate: z.string().optional(),
  endTime: z.string().optional(),
  eventVenue: z.string().optional(),
  meetUrl: z.string().optional(),
});

export type LessonFormValues = z.infer<typeof lessonSchema>;
